export const VERIFY_MAPPING_FIELDS_DATA_REQUEST =
  'VERIFY_MAPPING_FIELDS_DATA_REQUEST';
export const VERIFY_MAPPING_FIELDS_DATA_SUCCESS =
  'VERIFY_MAPPING_FIELDS_DATA_SUCCESS';
export const VERIFY_MAPPING_FIELDS_DATA_FAIL =
  'VERIFY_MAPPING_FIELDS_DATA_FAIL';
